import { memo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';
import { useRelevancyOptions } from '../store';

import SandEComponent from './SandEComponent';

import { useArticleLinkRule } from '@hooks/useLinkRule';

const trackingData = {
  name: 'TOTW',
  category: 'sponsored card',
};

const fallbackImg = `${window.imgBaseUrl}/imgml/uefacom/${window.competitionFolder}/fallback.jpg`;

export const TotwComponent = (props: RelevancyCardProps) => {
  const { item } = props;
  const { options } = useRelevancyOptions();

  const href = useArticleLinkRule(item?.teaser?.id);

  return (
    <SandEComponent
      {...props}
      cardType='totw'
      buttonTag='totw-card-cta'
      tag={`${options.competitionCode}.WINNER.FPZ`.toUpperCase()}
      url={href}
      fallbackImg={fallbackImg}
      trackingData={trackingData}
    />
  );
};

export default memo(TotwComponent);
